<div class="content p-4">

    <div class="text-md font-semibold text-primary mb-4">{{publicationAccessService.pubUuid}}</div>
    <button mat-stroked-button (click)="checkAgain()">
        <mat-icon [svgIcon]="'heroicons_solid:refresh'"></mat-icon>
        <span class="ml-1">{{'Force evaluation'|transloco}}</span>
    </button>

    <div class="mt-3 text-sm font-semibold text-primary">{{'Publications (édition client)'|transloco}}</div>
    <div class="flex flex-wrap items-center gap-2 mt-1">
        <ng-container *ngIf="loadingLinkedPublications">
            <span class="text-sm opacity-70">{{'Chargement…'|transloco}}</span>
        </ng-container>
        <ng-container *ngIf="!loadingLinkedPublications && linkedPublications.length">
            <a *ngFor="let p of linkedPublications"
               [href]="clientAppUrl + '/publications/edit/' + p.publicationUuid"
               class="mat-stroked-button inline-flex items-center"
               [class.ring-2]="p.publicationUuid === publicationUuid"
               [class.ring-primary-500]="p.publicationUuid === publicationUuid"
               target="_blank"
               rel="noopener noreferrer">
                <mat-icon [svgIcon]="'heroicons_solid:external-link'"></mat-icon>
                <span class="ml-1 max-w-xs truncate">{{ p.title || p.publicationUuid }}</span>
                <span *ngIf="p.publicationUuid === publicationUuid" class="ml-1 text-xs font-semibold text-primary">({{'courante'|transloco}})</span>
                <span *ngIf="p.isDefault" class="ml-1 text-xs opacity-60">(default)</span>
                <span *ngIf="!p.published" class="ml-1 text-xs opacity-60">(inactive)</span>
            </a>
        </ng-container>
        <ng-container *ngIf="!loadingLinkedPublications && !linkedPublications.length && surveyIds.length">
            <span class="text-sm opacity-70">{{'Aucune publication trouvée pour ces sondages.'|transloco}}</span>
        </ng-container>
        <ng-container *ngIf="!surveyIds.length && (publicationAccessService.hasPendingRequest$|async)">
            <span class="text-sm opacity-70">{{'Chargement du contexte publication…'|transloco}}</span>
        </ng-container>
        <ng-container *ngIf="!surveyIds.length && !(publicationAccessService.hasPendingRequest$|async) && publicationUuid">
            <span class="text-sm opacity-70">{{'Aucun identifiant de sondage disponible. Lancez « Force evaluation » ou rechargez la page.'|transloco}}</span>
        </ng-container>
    </div>

    <div class="flex flex-col h-full pt-2 anotherBody">

        <mat-tab-group #tabGroup [dynamicHeight]="false" class="h-full">

            <mat-tab label="{{'Rules'|transloco}}" bodyClass="h-full pt-2">
                <ng-template matTabContent>

                    <ng-container *ngIf="(publicationAccessService.allGroups$|async) as pubGroup">

                        <div class="mt-4 text-md font-semibold text-primary">{{'Publications élues / sélectionnées :'|transloco}}</div>

                        <ng-container *ngIf="(evalResultDebug?.sqlFake?.result) as result">
                            <div *ngFor="let agroup of result">

                                <div>{{agroup.pubUuid}} / {{agroup.groupId}}</div>
                                <div>
                                    {{pubGroup.data[agroup.groupId]|json}}
                                </div>

                            </div>
                        </ng-container>

                        <div class="mt-4 text-md font-semibold text-primary">Table What</div>

                        <pre>{{electedGroupIndex|json}}</pre>

                        <ng-container *ngIf="evalResultDebug?.sql3">
                            <div class="mb-2 lock p-6 w-full bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
                                 *ngFor="let aGroup of evalResultDebug.sql3.result"
                                 [ngClass]="{'rule-match border-4': electedGroupIndex.includes(aGroup.groupId)}"
                            >

                                <div class="text-xl mb-1">{{aGroup.groupTitle}} ({{aGroup.groupId}})
                                    / {{aGroup.comId}}</div>

                                <textarea fuse-highlight lang="sql">{{aGroup.sqlRule}}</textarea>
                                <div class="text-md m-2">ExtValues {{aGroup.fields|json}} :</div>
                                <textarea fuse-highlight
                                          lang="json">{{extValuesPerGroup[aGroup.groupId]|json}}</textarea>

                            </div>
                        </ng-container>

                    </ng-container>

                </ng-template>
            </mat-tab>

            <mat-tab label="{{'Surveys'|transloco}}" bodyClass="h-full pt-2">
                <ng-template matTabContent>
                    <div class="p-4 flex flex-roww">
                        <a *ngFor="let id of surveyIds" [href]="clientAppUrl + '/survey/builder/' + id" class="mat-stroked-button" target="_blank">
                            {{'Edit survey'|transloco}} <span class="font-bold ml-2">{{id}}</span><b></b>
                        </a>
                    </div>
                </ng-template>
            </mat-tab>

            <mat-tab label="Messages" bodyClass="h-full pt-2">
                <ng-template matTabContent>
                    <ng-container *ngIf="(publicationMessagesService.messages$|async) as messages">
                        <ng-container *ngIf="messages.index?.length; else noPubMessages">
                            <div *ngFor="let aMindex of messages.index">
                                <pre>{{messages.data[aMindex]|json}}</pre>
                            </div>
                        </ng-container>
                        <ng-template #noPubMessages>
                            <p class="text-sm opacity-70 p-4">{{'Aucun message de publication (liste vide).'|transloco}}</p>
                        </ng-template>
                    </ng-container>
                </ng-template>
            </mat-tab>

            <mat-tab label="Info" bodyClass="h-full pt-2">
                <ng-template matTabContent>
                    <ng-container *ngIf="publicationAccessService.publication$|async as pub">
                        <div class="p-4 text-sm space-y-2 border-b border-gray-200 dark:border-gray-700">
                            <div><span class="font-semibold text-primary">Titre publication</span> :
                                {{ pub.generalInfo?.title || '—' }}</div>
                            <div><span class="font-semibold text-primary">pubUuid</span> : {{ pub.pubUuid || '—' }}</div>
                        </div>
                        <ng-container *ngIf="(debugInfos.publication?.redirectInfos || pub.redirectInfos) as ri">
                            <div class="mt-4 mb-4 px-4 text-md font-semibold text-primary">
                                <span>{{'Redirect Infos'|transloco}}</span>
                                <span class="ml-1 px-4 py-2 rounded-full text-white bg-warn-300 font-semibold text-sm align-center"
                                      *ngIf="ri && !ri?.hasRedirectionLinks">{{'Liens non activés ?'|transloco}}</span>
                            </div>
                            <div class="px-4 text-sm opacity-80"
                                 *ngIf="ri && !ri?.complete && !ri?.screenout && !ri?.hasRedirectionLinks">
                                {{'Pas de liens de redirection dans les métadonnées chargées.'|transloco}}
                            </div>
                            <div class="px-4" *ngIf="ri?.complete">
                                <a [href]="ri.complete" target="_blank" rel="noopener noreferrer">Complete
                                    : {{ri.complete}}</a>
                            </div>
                            <div class="px-4" *ngIf="ri?.screenout">
                                <a [href]="ri.screenout" target="_blank" rel="noopener noreferrer">Screenout
                                    : {{ri.screenout}}</a>
                            </div>
                        </ng-container>
                        <div *ngIf="!(debugInfos.publication?.redirectInfos || pub.redirectInfos)" class="p-4 text-sm opacity-70">
                            redirectInfos absent (réponse API incomplète).
                        </div>

                        <div class="mt-4 px-4 text-md font-semibold text-primary">{{'Publication (infos)'|transloco}}</div>
                        <pre class="px-4 pb-4 text-xs overflow-auto max-h-96">{{pub|json}}</pre>
                    </ng-container>
                </ng-template>
            </mat-tab>

            <mat-tab label="Debug" bodyClass="h-full pt-2">
                <ng-template matTabContent>
                    <pre>{{debugInfos|json}}</pre>
                </ng-template>
            </mat-tab>

        </mat-tab-group>

    </div>

</div>
